<template>
    <Link :href="url" class="p-button p-button-sm border-green-500 bg-green-500 hover:bg-green-600">
        <IconAdd class="mr-1" />
        <slot></slot>
    </Link>
</template>
<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import IconAdd from '@/Icons/Add'

    export default defineComponent({
        components: {
            Link,
            IconAdd,
        },
        props: ['url'],
    })
</script>